module.exports = __webpack_public_path__ + "img/combat-shop.d06f1fdf.png";